import { updateAnalysisPeriscope } from '../../redux/application/actions';
import { useAction } from '@hooks/useAction';
import { useCallback } from 'react';
import { useSonarSelector } from '@hooks/useSonarSelector';
export function useAnalysisPeriscope() {
    const hasAnalysisCard = useSonarSelector((state) => Boolean(state.application.periscope.analysisTarget));
    const updateTarget = useAction(updateAnalysisPeriscope);
    const open = useCallback((sonarObjectId, type) => {
        if (hasAnalysisCard) {
            return;
        }
        updateTarget({
            id: sonarObjectId,
            name: '',
            type
        });
    }, [hasAnalysisCard, updateTarget]);
    return { open };
}
